import { render, staticRenderFns } from "./ModalFilterClientView..vue?vue&type=template&id=3796e059"
import script from "./ModalFilterClientView..vue?vue&type=script&lang=js"
export * from "./ModalFilterClientView..vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports